import { RestSchemas } from '@/contexts/QueryProvider'
import { useGetSearchParam } from '@/hooks/useGetSearchParams'
import { isApplicationAdmin, isSuperUser } from '@/util'
import { SelectTabData, SelectTabEvent, Tab, TabList } from '@fluentui/react-components'
import { useSearchParams } from 'react-router-dom'
import {
  AppGeneric24Regular,
  TextBulletList24Regular,
  PersonBoard24Regular,
  CheckboxPerson24Regular,
  BoardSplit24Regular,
  CubeSync24Regular,
} from '@fluentui/react-icons'
import { AppAccessesPanel } from '../ApplicationAccessPanel'
import { AppDetailsPanel } from '../AppDetailsPanel'
import { AppMarketingPanel } from '../AppMarketingPanel'
import { AppRolesPanel } from '../AppRolesPanel'
import { AppSyncPanel } from '../AppSyncPanel'
import { AppTeamsPanel } from '../../AppTeamsPanel/AppTeamsPanel'
import { AppPermsPanel } from '../AppPermsPanel'
import { useSessionStorage } from '@/hooks/useSessionStorage'
import DatabricksIcon from '../DatabricksIcon'
import { isDatabricksApp } from '@/util/appTypes'
import { DatabricksPanel } from '../DatabricksPanel'
import { MenuBuilderPanel } from '../ApplicationMenuBuilder/MenuBuilderPanel'

type MessagesApplicationsApplication = RestSchemas['Messages.Applications.Application']

export function ApplicationTabs({ app }: { app?: MessagesApplicationsApplication }) {
  const [userRole] = useSessionStorage('roles', 1)

  const tab = useGetSearchParam<string>('tab')
  const isAppAdmin = isSuperUser(userRole) || isApplicationAdmin(userRole)
  const [searchParams, setSearchParams] = useSearchParams()

  if (!app || !tab) {
    return null
  }

  const appId = app.applicationId
  const showDatabricks = isDatabricksApp(app.appTypes)

  const onTabSelect = (_event: SelectTabEvent, data: SelectTabData) => {
    searchParams.set('tab', data.value as string)
    setSearchParams(searchParams)
  }

  return (
    <>
      <TabList selectedValue={tab} onTabSelect={onTabSelect}>
        <Tab id="details" icon={<AppGeneric24Regular />} value="details">
          Details
        </Tab>
        <Tab id="menu" icon={<TextBulletList24Regular />} value="menu">
          Menu builder
        </Tab>
        <Tab id="roles" icon={<PersonBoard24Regular />} value="roles">
          Roles
        </Tab>
        <Tab id="perms" icon={<CheckboxPerson24Regular />} value="perms">
          Permissions
        </Tab>
        <Tab id="accesses" icon={<CheckboxPerson24Regular />} value="accesses">
          Accesses
        </Tab>
        <Tab id="teams" icon={<PersonBoard24Regular />} value="teams">
          Teams
        </Tab>
        <Tab id="marketing" icon={<BoardSplit24Regular />} value="marketing">
          Marketing
        </Tab>
        <Tab id="sync" icon={<CubeSync24Regular />} value="sync" disabled={!isAppAdmin}>
          Sync
        </Tab>
        {showDatabricks && (
          <Tab id="databricks" icon={<DatabricksIcon />} value="databricks">
            Databricks
          </Tab>
        )}
      </TabList>
      <div style={{ padding: '10px' }}>
        {tab === 'details' && <AppDetailsPanel />}
        {tab === 'menu' && <MenuBuilderPanel />}
        {tab === 'roles' && <AppRolesPanel appId={appId} />}
        {tab === 'perms' && <AppPermsPanel appId={appId} />}
        {tab === 'accesses' && <AppAccessesPanel appId={appId} />}
        {tab === 'teams' && <AppTeamsPanel appId={appId} />}
        {tab === 'marketing' && <AppMarketingPanel />}
        {tab === 'sync' && <AppSyncPanel app={app} />}
        {tab === 'databricks' && <DatabricksPanel appId={appId} />}
      </div>
    </>
  )
}
